var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFootballIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 188,
    viewBox: "0 0 188 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2131_376)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 93.8485,
    cy: 89.8485,
    r: 87.3485,
    fill: "#0077FF",
    stroke: "#0C0F14",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.719 87.3249C168.477 126.636 136.177 159.246 95.4391 160.031C54.7008 160.816 21.1691 129.474 20.4117 90.1632C19.6542 50.852 51.9537 18.2422 92.6921 17.4573C133.43 16.6723 166.962 48.0138 167.719 87.3249Z",
    fill: "white",
    stroke: "#0C0F14",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9819 125.665L58.6182 105.341C58.3637 108.559 58.3001 111.904 58.4273 115.376C58.5546 118.848 58.8728 121.939 59.3819 124.649C61.3334 125.242 64.2819 125.623 68.2273 125.792C72.1728 125.961 75.7576 125.919 78.9819 125.665ZM91.2001 123.633C96.2061 122.532 100.703 120.965 104.691 118.933C108.679 116.9 112.158 114.402 115.127 111.438C118.012 108.559 120.473 105.15 122.509 101.212C124.546 97.2744 126.158 92.8073 127.346 87.8109L96.5455 57.0704C91.7092 58.2559 87.3395 59.8861 83.4364 61.9609C79.5334 64.0357 76.097 66.555 73.1273 69.519C70.1576 72.483 67.6334 75.9339 65.5546 79.8717C63.4758 83.8095 61.8425 88.2343 60.6546 93.146L91.2001 123.633ZM83.3092 108.135L76.1819 101.022L104.691 72.5677L111.818 79.6812L83.3092 108.135ZM129.382 75.6163C129.721 72.3136 129.827 68.8839 129.7 65.3271C129.573 61.7704 129.212 58.6794 128.618 56.0541C126.667 55.3767 123.718 54.9532 119.773 54.7839C115.827 54.6145 112.242 54.6992 109.018 55.0379L129.382 75.6163ZM72.3637 136.081C67.5273 136.081 63.1152 135.721 59.1273 135.001C55.1395 134.282 52.6789 133.456 51.7455 132.524C50.8122 131.508 49.9849 128.968 49.2637 124.903C48.5425 120.838 48.1819 116.35 48.1819 111.438C48.1819 101.36 49.7092 92.024 52.7637 83.4285C55.8182 74.833 60.1455 67.7406 65.7455 62.1514C71.3455 56.5622 78.5152 52.2433 87.2546 49.1947C95.994 46.146 105.455 44.6217 115.636 44.6217C120.558 44.6217 124.991 44.9816 128.936 45.7014C132.882 46.4213 135.321 47.2469 136.255 48.1785C137.188 49.1947 138.015 51.7352 138.736 55.8001C139.458 59.865 139.818 64.4379 139.818 69.519C139.818 79.4271 138.291 88.6789 135.236 97.2744C132.182 105.87 127.855 112.962 122.255 118.551C116.739 124.056 109.612 128.354 100.873 131.445C92.1334 134.536 82.6304 136.081 72.3637 136.081Z",
    fill: "#0C0F14"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2131_376",
    x: 0,
    y: 0,
    width: 187.697,
    height: 187.697,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2131_376"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2131_376",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootballIcon);
export default __webpack_public_path__ + "static/media/FootballIcon.56325e773ecf51b44ed36df191cd79e4.svg";
export { ForwardRef as ReactComponent };